// plugins/base-url.js
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  nuxtApp.provide('getAssetUrl', (path) => {
    return `${config.public.baseURL}${path}`;
  });
});
